import { isTestAccount } from "../helpers";
export function makeUserData(params) {
    const { uid, handle, email, full_name = "", isAnonymous = false, is_test, picture = "", sign_up_referrer = "", sign_up_page_referrer = "", parts_count = 0, documents_count = 0, follower_count = 0, following_count = 0, star_count = 0, created_at = Date.now(), updated_at = Date.now(), } = params;
    const partialUser = {
        ...params,
        uid,
        handle,
        email,
        full_name,
        isAnonymous,
        picture,
        sign_up_referrer,
        sign_up_page_referrer,
        parts_count,
        documents_count,
        follower_count,
        following_count,
        star_count,
        created_at,
        updated_at,
    };
    return {
        ...partialUser,
        is_test: is_test ?? isTestAccount(partialUser, "strict"),
    };
}
//# sourceMappingURL=lifecycle.js.map